import React from 'react'

import AvailabilityStore from '../stores/AvailabilityStore.js'
import AvailabilityActions from '../actions/AvailabilityActions.js'

import { translate } from 'react-i18next';

var PreOrderBlock = React.createClass({


  getInitialState() {
    return {store: AvailabilityStore.getState()};
  },

  componentDidMount() {
    AvailabilityStore.listen(this.onChange);

  },

  componentWillUnmount() {
    AvailabilityStore.unlisten(this.onChange);
  },

  onChange(state) {
    this.setState({store: state});
  },

  stopCollapse() {
    AvailabilityActions.stopPreOrderCollapse();
  },

  showPreOrder() {
    AvailabilityActions.setPreOrderCollapseState('collapsing_min');
    setTimeout(function() {
      AvailabilityActions.setPreOrderCollapseState('collapsing_max');
      setTimeout(function() {
        AvailabilityActions.setPreOrderCollapseState('collapse_in');
      }, 350);
    }, 0); // .35s easing
  },

  hidePreOrder() {
    AvailabilityActions.setPreOrderCollapseState('collapsing_max');
    setTimeout(function() {
      AvailabilityActions.setPreOrderCollapseState('collapsing_min');
      setTimeout(function() {
        AvailabilityActions.setPreOrderCollapseState('collapse');
      }, 350);
    }, 0); // .35s easing
  },

  render() {
      const { t } = this.props;
      var store = this.state.store;

      let method = null;
      let collapse_class = '';
      let collapse_height = 0;

      let window_width = document.documentElement.clientWidth || window.innerWidth;
      let collapse_max = 1094;
      if(window_width > 992) {
        collapse_max = 585;
      } else if(window_width > 768) {
        collapse_max = 649;
      }

      switch(store.get('show_preorder')) {
        case 'collapse_in':
          collapse_class = 'collapse in';
          method = this.hidePreOrder;
          break;
        case 'collapse':
          collapse_class = 'collapse offcanvas';
          method = this.showPreOrder;
          break;
        case 'collapsing_max':
          collapse_class = 'collapsing';
          collapse_height = collapse_max;
          break;
        case 'collapsing_min':
          collapse_class = 'collapsing';
          collapse_height = 0;
          break;
      }

    return (
      <div>
      <div className="row preorder_block">
        <p className="preorder_block__title">Begin your service request by choosing from the options below:</p>

        <div role="tab" id="headingOne">

          <p className="preorder_block__link_container">

            <a onClick={method} className="preorder_block__link" data-parent="#accordion" aria-expanded="true" aria-controls="collapseOne">What is a pre-order? <span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span></a>
          </p>
        </div>

      </div>

      <div className={"container stepContainer preorder_block__collapse "+collapse_class} style={(collapse_height ? {height: collapse_height+'px'} : {})}>
      <div className="preorder_block__collapse__inner">
      <div className="row">
        <div className="col-xs-12">
          <p className="preorder_block__title2">What is a fiber pre-order?</p>
          <p className="preorder_block__description">First of all, congratulations on being able to pre-order the fastest, cheapest internet available to you! A pre-order is your ticket to being first in line to receive Gigabit Fiber service in your area (and a great way to make your neighbors jealous). When you pre-order, you get: </p>
        </div>

        <div className="col-xs-12">
          <div className="row">
            <div className="col-xs-12 col-sm-4 preorder_block__bullet_column">
              <p ><img src="https://www.sonic.com/sites/default/files/avail_preorder_updates.png"/></p>
              <p className="preorder_block__description"><b>Monthly construction updates</b> and <b>progress emails regarding the status</b> of the network build-out in your area.</p>
            </div>
            <div className="col-xs-12 col-sm-4 preorder_block__bullet_column">
              <p ><img src="https://www.sonic.com/sites/default/files/avail_preorder_priority.png" /></p>
              <p className="preorder_block__description"><b>Priority installation</b> — as soon as service is live and available, we’ll reach out to you so you’re one of the very first ones connected in your neighborhood.</p>
            </div>
            <div className="col-xs-12 col-sm-4 preorder_block__bullet_column">
              <p ><img src="https://www.sonic.com/sites/default/files/avail_preorder_credit.png"  /></p>
              <p className="preorder_block__description"><b>Contract buyout</b> — Pre-order now, and we’ll buy you out of your contract (up to $200) once we’re ready to turn your service on!</p>
            </div>
          </div>
        </div>

        <div className="col-xs-12" className="preorder_block__description">
          <p>We don't share final service delivery timelines, but we are making daily progress in every one of our build-outs and activating new neighborhoods every week. </p>
        </div>
        </div>
      </div>
      </div>
      </div>
    );
  }
});

export default  translate('common', { wait: true })(PreOrderBlock);